import React, { useState } from "react"

import paxIcon from "../img/pax-icon.svg"
import hugLinkIcon from "../img/hug-link-icon.svg"
import erpIcon from "../img/erp-icon.svg"
import mainLogoImg from "../img/hug-header-logo.svg"
import mobMenuIcon from "../img/mob-menu-icon.svg"

import "../style/header.css";

function Header() {
    const [ menuOpened, setMenuOpened ] = useState(false);

    return (
        <React.Fragment>
            <header className="header-container">
                <div className="top-links">
                    <div>
                        <span>Acesse Nossas Plataformas</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="19" viewBox="0 0 27 19" fill="none">
                            <path d="M16.9451 17.7475C16.4078 17.2102 16.4078 16.3423 16.9451 15.805L22.2765 10.446H1.37765C0.619942 10.446 0 9.82606 0 9.06836C0 8.31065 0.619942 7.69071 1.37765 7.69071H22.2765L16.9313 2.34544C16.394 1.80816 16.394 0.940243 16.9313 0.402961C17.4686 -0.13432 18.3365 -0.13432 18.8738 0.402961L26.5886 8.104C27.1259 8.64129 27.1259 9.5092 26.5886 10.0465L18.8875 17.7475C18.3503 18.271 17.4686 18.271 16.9451 17.7475Z" fill="#E2521A"/>
                        </svg>
                    </div>

                    <a href="#pax">
                        <img src={paxIcon} alt="pax-icon" className="pax-icon" />
                    </a>

                    <a href="#link">
                        <img src={hugLinkIcon} alt="hug-link-icon" className="hug-liink-icon" />
                    </a>

                    <a href="#erp">
                        <img src={erpIcon} alt="erp-icon" className="erp-icon" />
                    </a>
                </div>

                <div className="main-header">
                    <img src={mainLogoImg} alt="main-logo-img" className="main-logo-img" />

                    <nav>
                        <ul className="nav-list">
                            <li className="nav-item">
                                <a href="#">Home</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Metodologias HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Programas HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Sobre Nós</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Espaço HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Seja um Parceiro</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Contato</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
            
            <div className="header-container-mob">
                <div className="main-header-mob">
                    <img src={mainLogoImg} alt="main-logo-img" className="main-logo-img" />
                    <button className="menu-button" onClick={() => setMenuOpened(!menuOpened)}>
                        <img src={mobMenuIcon} onClick={() => setMenuOpened(!menuOpened)}/>
                    </button>
                </div>

                <div className={menuOpened ? "menu-wrapper-mob open" : "menu-wrapper-mob"}>
                    <nav>
                        <ul className="nav-list">
                            <li className="nav-item">
                                <a href="#">Home</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Metodologias HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Programas HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Sobre Nós</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Espaço HUG</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Seja um Parceiro</a>
                            </li>
                            <li className="nav-item">
                                <a href="#">Contato</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

        </React.Fragment>
    )
}

export default Header;